import React from 'react'
import clsx from 'clsx'
import { Tag as AntTag } from 'antd'
import { TagProps as AntTagProps, CheckableTagProps } from 'antd/lib/tag'

import './Tag.css'

type Props = AntTagProps

type CheckableTag = CheckableTagProps & {
  disabled?: boolean
}

export const Tag: React.FC<Props> = ({
  children,
  className,
  closable,
  color,
  icon,
  onClose,
  ...rest
}) => {
  return (
    <AntTag
      className={className}
      closable={closable}
      color={color}
      icon={icon}
      onClose={onClose}
      {...rest}
    >
      {children}
    </AntTag>
  )
}

export const CheckableTag: React.FC<CheckableTag> = ({
  prefixCls,
  className,
  style,
  checked,
  onChange,
  onClick,
  children,
  disabled = false,
}) => {
  return (
    <AntTag.CheckableTag
      className={clsx(className, {
        'disabledChecked': checked && disabled,
        'disabledUnChecked': disabled
      })}
      checked={checked}
      onChange={onChange}
      onClick={onClick}
      style={style}
      prefixCls={prefixCls}
    >
      {children}
    </AntTag.CheckableTag>
  )
}
